import { BareFetcher, preload, SWRConfiguration } from 'swr';
import useSWRImmutable from 'swr/immutable';
import { QueryKey } from '@/api/queryKey';
import { getSchoolSettingBySchoolId } from '@/api/school';
import { SchoolSetting } from '@/model/SchoolSetting/SchoolSetting.model';

type Options = SWRConfiguration<SchoolSetting | null, unknown, BareFetcher<SchoolSetting | null>>;

export const useSchoolSettingBySchoolId = (schoolId: string | undefined, options?: Options) => {
  const swrResponse = useSWRImmutable(
    () => QueryKey.GetSchoolSettingBySchoolId(schoolId),
    () => (schoolId ? getSchoolSettingBySchoolId(schoolId) : null),
    options
  );

  return swrResponse;
};

export const preloadSchoolSettingBySchoolId = (schoolId: string) => {
  return preload(QueryKey.GetSchoolSettingBySchoolId(schoolId), () => getSchoolSettingBySchoolId(schoolId));
};
